import React, { useState } from "react";
import { View } from "react-native";

import { openURL, getContactMailUrl } from "../../../helpers/utils";
import { buttonStyle } from "../common/ActionsMenuButton/utils";
import ActionButton from "../common/ActionsMenuButton/ActionButton";
import InviteIcon from "../common/ActionsMenuButton/icons/InviteIcon";
import RoutinesIcon from "../common/icons/RoutinesIcon";

export default function RoutinesPageFabButton({
  mariOptions = {},
  style = {},
  createNewRoutine = () => {},
}) {
  const [actionButton, setActionButton] = useState(null);

  return (
    <View
      style={[buttonStyle, style]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        zIndex={999}
        source={"EditReflectionFabButton"}
      >
        <ActionButton.Item
          underline
          hideShadow
          buttonColor="#FFF"
          title="Help"
          onPress={() => {
            openURL(getContactMailUrl());
          }}
        >
          <InviteIcon />
        </ActionButton.Item>

        <ActionButton.Item
          hideShadow
          buttonColor="#FFF"
          title="New Week Routine"
          onPress={() => createNewRoutine("week")}
        >
          <RoutinesIcon />
        </ActionButton.Item>

        <ActionButton.Item
          hideShadow
          buttonColor="#FFF"
          title="New Routine"
          onPress={() => createNewRoutine()}
        >
          <RoutinesIcon />
        </ActionButton.Item>
      </ActionButton>
    </View>
  );
}
